import React from 'react';

import { ServicePageLayoutComponent } from 'design/servicePageLayout';
import { TextComponent } from 'design/text/textComponents';
import { LinkControlComponent } from 'design/linkControl/linkControlComponents';
import { useAppDispatcher } from 'hooks/useAppDispatcher';
import { ORIGIN_SITE_URL } from 'utils/constants';
import { LogoComponent } from 'design/logo';
import { ImplicitAuthWidget } from 'containers/ImplicitAuthWidget';

export const SignInPage = () => {
  const dispatch = useAppDispatcher();

  const handleEmailConfirmed = React.useCallback(() => {
    dispatch({
      name: 'SignInPage__SignedIn',
    });
  }, [dispatch]);

  return (
    <ServicePageLayoutComponent
      sidebarContent={
        <LinkControlComponent to={ORIGIN_SITE_URL}>
          <TextComponent size="l">
            <LogoComponent />
          </TextComponent>
        </LinkControlComponent>
      }
      bodyContent={
        <ImplicitAuthWidget onEmailConfirmed={handleEmailConfirmed} />
      }
    />
  );
};
